"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// src/jsx/Star.tsx
function Star(props) {
  return /* @__PURE__ */ React__namespace.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ...props
  }, /* @__PURE__ */ React__namespace.createElement("path", {
    d: "M10.654 2.47c.55-1.117 2.142-1.117 2.692 0l2.419 4.916 5.366.778c1.235.179 1.724 1.701.823 2.566l-3.878 3.723.937 5.384c.212 1.221-1.065 2.159-2.166 1.59L12 18.925l-4.847 2.502c-1.102.569-2.378-.369-2.166-1.59l.937-5.384-3.878-3.723c-.901-.865-.413-2.387.823-2.566l5.366-.778 2.42-4.916z"
  }));
}
var Star_default = Star;

exports.Star_default = Star_default;
